import Form from './Form.view';

export default Form;
